import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { PortalAuthService } from './portal-auth.service';
import { map, take } from 'rxjs/operators';

export const authGuard: CanActivateFn = (route, state) => {
  const authService = inject(PortalAuthService);
  const router = inject(Router);

  return authService.isAuthenticated().pipe(
    take(1),
    map(isAuthenticated => {
      if (isAuthenticated) {
        return true;
      } else {
        // Store the attempted URL for redirecting after login
        localStorage.setItem('redirectUrl', state.url);
        router.navigate(['/']);
        return false;
      }
    })
  );
};
